import { VehicleTypeRouteGroupInput } from './vehicle-type-route-group-input.model';
import { VehicleGroupRouteGroupInput } from './vehicle-group-route-group-input.model';
import { VehicleDetailsRouteGroupInput } from './vehicle-details-route-group-input.model';
import { BranchDetailsRouteGroupInput } from './branch-details-route-group-input.model';
import { RoutePathRouteGroupInput } from './route-path-route-group-input.model';


export class RouteGroupUpdateInput implements IRouteGroupUpdateInput {
    /** The auto-generated id of the route group master */
    routeGroupId!: number;
    /** The auto-generated id of the company details master */
    companyDetailsId!: number;
    /** The branch details type must be one of "All" or "Select" */
    branchDetailType!: string;
    /** The vehicle type must be one of "Vehicle Type" or "Vehicle Group" */
    vehicle!: string;
    /** The vehicle type must be one of "All" or "Selected" */
    vehicleType!: string;
    /** The vehicle group must be one of "All" or "Selected" */
    vehicleGroup!: string;
    /** The vehicle number type must be one of "All" or "Select" */
    vehicleNumber!: string;
    /** The route group name with 500 character limit */
    routeGroupName!: string;
    vehicleTypeRouteGroup!: VehicleTypeRouteGroupInput[];
    vehicleGroupRouteGroup!: VehicleGroupRouteGroupInput[];
    vehicleDetailsRouteGroup!: VehicleDetailsRouteGroupInput[];
    branchDetailsRouteGroup!: BranchDetailsRouteGroupInput[];
    routePathRouteGroup!: RoutePathRouteGroupInput[];

    constructor(data?: IRouteGroupUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routeGroupId = _data["routeGroupId"];
            this.companyDetailsId = _data["companyDetailsId"];
            this.branchDetailType = _data["branchDetailType"];
            this.vehicle = _data["vehicle"];
            this.vehicleType = _data["vehicleType"];
            this.vehicleGroup = _data["vehicleGroup"];
            this.vehicleNumber = _data["vehicleNumber"];
            this.routeGroupName = _data["routeGroupName"];
            if (Array.isArray(_data["vehicleTypeRouteGroup"])) {
                this.vehicleTypeRouteGroup = [] as any;
                for (let item of _data["vehicleTypeRouteGroup"])
                    this.vehicleTypeRouteGroup!.push(VehicleTypeRouteGroupInput.fromJS(item));
            }
            if (Array.isArray(_data["vehicleGroupRouteGroup"])) {
                this.vehicleGroupRouteGroup = [] as any;
                for (let item of _data["vehicleGroupRouteGroup"])
                    this.vehicleGroupRouteGroup!.push(VehicleGroupRouteGroupInput.fromJS(item));
            }
            if (Array.isArray(_data["vehicleDetailsRouteGroup"])) {
                this.vehicleDetailsRouteGroup = [] as any;
                for (let item of _data["vehicleDetailsRouteGroup"])
                    this.vehicleDetailsRouteGroup!.push(VehicleDetailsRouteGroupInput.fromJS(item));
            }
            if (Array.isArray(_data["branchDetailsRouteGroup"])) {
                this.branchDetailsRouteGroup = [] as any;
                for (let item of _data["branchDetailsRouteGroup"])
                    this.branchDetailsRouteGroup!.push(BranchDetailsRouteGroupInput.fromJS(item));
            }
            if (Array.isArray(_data["routePathRouteGroup"])) {
                this.routePathRouteGroup = [] as any;
                for (let item of _data["routePathRouteGroup"])
                    this.routePathRouteGroup!.push(RoutePathRouteGroupInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RouteGroupUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new RouteGroupUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routeGroupId"] = this.routeGroupId;
        data["companyDetailsId"] = this.companyDetailsId;
        data["branchDetailType"] = this.branchDetailType;
        data["vehicle"] = this.vehicle;
        data["vehicleType"] = this.vehicleType;
        data["vehicleGroup"] = this.vehicleGroup;
        data["vehicleNumber"] = this.vehicleNumber;
        data["routeGroupName"] = this.routeGroupName;
        if (Array.isArray(this.vehicleTypeRouteGroup)) {
            data["vehicleTypeRouteGroup"] = [];
            for (let item of this.vehicleTypeRouteGroup)
                data["vehicleTypeRouteGroup"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicleGroupRouteGroup)) {
            data["vehicleGroupRouteGroup"] = [];
            for (let item of this.vehicleGroupRouteGroup)
                data["vehicleGroupRouteGroup"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicleDetailsRouteGroup)) {
            data["vehicleDetailsRouteGroup"] = [];
            for (let item of this.vehicleDetailsRouteGroup)
                data["vehicleDetailsRouteGroup"].push(item.toJSON());
        }
        if (Array.isArray(this.branchDetailsRouteGroup)) {
            data["branchDetailsRouteGroup"] = [];
            for (let item of this.branchDetailsRouteGroup)
                data["branchDetailsRouteGroup"].push(item.toJSON());
        }
        if (Array.isArray(this.routePathRouteGroup)) {
            data["routePathRouteGroup"] = [];
            for (let item of this.routePathRouteGroup)
                data["routePathRouteGroup"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRouteGroupUpdateInput {
    /** The auto-generated id of the route group master */
    routeGroupId: number;
    /** The auto-generated id of the company details master */
    companyDetailsId: number;
    /** The branch details type must be one of "All" or "Select" */
    branchDetailType: string;
    /** The vehicle type must be one of "Vehicle Type" or "Vehicle Group" */
    vehicle: string;
    /** The vehicle type must be one of "All" or "Selected" */
    vehicleType: string;
    /** The vehicle group must be one of "All" or "Selected" */
    vehicleGroup: string;
    /** The vehicle number type must be one of "All" or "Select" */
    vehicleNumber: string;
    /** The route group name with 500 character limit */
    routeGroupName: string;
    vehicleTypeRouteGroup: VehicleTypeRouteGroupInput[];
    vehicleGroupRouteGroup: VehicleGroupRouteGroupInput[];
    vehicleDetailsRouteGroup: VehicleDetailsRouteGroupInput[];
    branchDetailsRouteGroup: BranchDetailsRouteGroupInput[];
    routePathRouteGroup: RoutePathRouteGroupInput[];
}

